import {
  CLONE_TABLE_GRID_HEADER_HEIGHT,
  CLONE_TABLE_ROW_HEIGHT,
} from '@/features/shared/components/cloneTable/cloneTableConstants';
import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

export const cloneTableSx: SxProps<Theme> = {
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnSeparator': {
    color: 'divider',
    display: 'flex !important',
    opacity: '1 !important',
    visibility: 'visible !important',
    pointerEvents: 'auto !important',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnSeparator--sideRight': {
    display: 'flex !important',
    opacity: '1 !important',
    visibility: 'visible !important',
    pointerEvents: 'auto !important',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnSeparator--sideLeft': {
    display: 'flex !important',
    opacity: '1 !important',
    visibility: 'visible !important',
    pointerEvents: 'auto !important',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-iconSeparator': {
    color: 'divider',
    display: 'block !important',
    opacity: '1 !important',
    visibility: 'visible !important',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnSeparator svg': {
    display: 'block !important',
    opacity: '1 !important',
    visibility: 'visible !important',
  },
  '& .MuiDataGrid-columnsManagementHeader': {
    display: 'none !important',
  },
  '& .MuiDataGrid-columnsManagementFooter': {
    display: 'none !important',
  },
  '& .MuiDataGrid-paper': {
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    boxShadow: 'none',
    overflow: 'hidden',
  },
  '& .MuiDataGrid-panelWrapper': {
    p: 0,
    backgroundColor: 'background.paper',
  },
  '& .MuiDataGrid-panelContent': {
    p: 0,
    backgroundColor: 'background.paper',
  },
  '& .MuiDataGrid-columnsManagement': {
    p: 0,
    backgroundColor: 'background.paper',
  },
  '& .MuiDataGrid-columnsManagementRow': {
    margin: 0,
    px: s('sm'),
    py: s('xs'),
    minHeight: 44,
    borderRadius: 0,
  },
  '& .MuiDataGrid-columnsManagementRow .MuiFormControlLabel-label': {
    fontSize: '1rem',
  },
  '& .MuiDataGrid-menuList, & .MuiDataGrid-menuList .MuiMenuItem-root': {
    backgroundColor: 'background.paper',
  },
  '& .MuiDataGrid-menuList .MuiMenuItem-root': {
    minHeight: 40,
    px: s('sm'),
    py: s('xs'),
  },
  '& .MuiDataGrid-menuList .MuiMenuItem-root.Mui-selected': {
    backgroundColor: 'action.hover',
  },
  '& .MuiDataGrid-menuList .MuiMenuItem-root.Mui-selected:hover': {
    backgroundColor: 'action.selected',
  },
  '& .MuiDataGrid-columnHeaderTitleContainer, & .MuiDataGrid-columnHeaderTitleContainerContent': {
    borderLeft: 'none !important',
    borderRight: 'none !important',
  },
  '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader--withRightBorder, & .MuiDataGrid-columnHeader--withLeftBorder':
    {
      borderRight: 'none !important',
      borderLeft: 'none !important',
    },
  '& .MuiDataGrid-columnHeader.MuiDataGrid-withBorderColor': {
    borderRight: 'none !important',
    borderLeft: 'none !important',
  },
  '& .MuiDataGrid-columnHeaders': {
    minHeight: `${CLONE_TABLE_GRID_HEADER_HEIGHT}px !important`,
    maxHeight: `${CLONE_TABLE_GRID_HEADER_HEIGHT}px !important`,
    height: `${CLONE_TABLE_GRID_HEADER_HEIGHT}px !important`,
  },
  '& .MuiDataGrid-columnHeader': {
    minHeight: `${CLONE_TABLE_GRID_HEADER_HEIGHT}px !important`,
    maxHeight: `${CLONE_TABLE_GRID_HEADER_HEIGHT}px !important`,
    height: `${CLONE_TABLE_GRID_HEADER_HEIGHT}px !important`,
  },
  '& .MuiDataGrid-cell--withRightBorder, & .MuiDataGrid-cell--withLeftBorder': {
    borderRight: 'none !important',
    borderLeft: 'none !important',
  },
  '& .MuiDataGrid-row': {
    minHeight: `${CLONE_TABLE_ROW_HEIGHT}px !important`,
    maxHeight: `${CLONE_TABLE_ROW_HEIGHT}px !important`,
  },
  '& .MuiDataGrid-cell': {
    minHeight: `${CLONE_TABLE_ROW_HEIGHT}px !important`,
    maxHeight: `${CLONE_TABLE_ROW_HEIGHT}px !important`,
    py: s('md'),
  },
  '& .MuiDataGrid-cell[data-field="name"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell.tests-table-clone-test-cell .MuiStack-root': {
    paddingTop: '4px',
  },
  '& .MuiDataGrid-cell[data-field="latestExecutionStatus"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell[data-field="latestBuildStatus"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell[data-field="actions"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell[data-field="testLatestExecutionPassed"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell.tests-table-clone-passrate-cell, & .MuiDataGrid-cell.tests-table-clone-frequency-cell, & .MuiDataGrid-cell.tests-table-clone-avgduration-cell':
    {
      overflow: 'visible',
    },
  '& .MuiDataGrid-cell.tests-table-clone-passrate-cell .MuiDataGrid-cellContent, & .MuiDataGrid-cell.tests-table-clone-frequency-cell .MuiDataGrid-cellContent, & .MuiDataGrid-cell.tests-table-clone-avgduration-cell .MuiDataGrid-cellContent':
    {
      overflow: 'visible',
    },
  '&.MuiDataGrid-loading .suite-latest-pie': {
    visibility: 'hidden',
  },
  '&& .MuiDataGrid-row, && .MuiDataGrid-row .MuiDataGrid-cell': {
    backgroundColor: 'transparent !important',
  },
  '&& .MuiDataGrid-row:hover, && .MuiDataGrid-row.Mui-hovered': {
    backgroundColor: 'transparent !important',
  },
  '&& .MuiDataGrid-row:hover .MuiDataGrid-cell, && .MuiDataGrid-row.Mui-hovered .MuiDataGrid-cell':
    {
      backgroundColor: 'transparent !important',
    },
  '&& .MuiDataGrid-row.Mui-selected, && .MuiDataGrid-row.Mui-selected:hover': {
    backgroundColor: 'transparent !important',
  },
  '&& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell, && .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell':
    {
      backgroundColor: 'transparent !important',
    },
};
